module.exports = __webpack_public_path__ + "img/Colorization2.3ca427c6.webp";